import styled from "styled-components";

export const Wrapper = styled.div`
  color: white;

  table {
    text-align: center;
    thead {
      tr {
        th {
          border: 40px solid transparent;
        }
      }
    }
  }
`;
